import { render, staticRenderFns } from "./AppBreadCrumbs.vue?vue&type=template&id=e60cad9a&"
import script from "./AppBreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./AppBreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./AppBreadCrumbs.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VIcon})
